/**
 * Lazy Firebase Auth loader.
 *
 * Keeps `firebase/auth` (~131 KB including the Auth iframe + gapi loader)
 * out of the main bundle. Auth is only needed for the loyalty phone-OTP
 * flow, so anonymous menu visitors should never pay the cost of loading it.
 *
 * Returns the configured `auth` instance plus all named exports of
 * `firebase/auth` so callers can do:
 *   const { auth, onAuthStateChanged, signOut } = await loadAuth();
 *
 * Callers:
 *   - CustomerIdentityContext mounts onAuthStateChanged only when a saved
 *     phone exists in sessionStorage (returning loyalty user).
 *   - PhoneVerificationModal calls loadAuth() when the modal opens.
 */
import { app } from './firebase';

let cachedPromise = null;

export function loadAuth() {
  if (cachedPromise) return cachedPromise;
  cachedPromise = (async () => {
    const mod = await import('firebase/auth');
    const auth = mod.getAuth(app);
    auth.useDeviceLanguage();
    if (import.meta.env.VITE_DISABLE_PHONE_VERIFICATION === 'true') {
      auth.settings.appVerificationDisabledForTesting = true;
      console.warn('🔧 Phone verification reCAPTCHA disabled — only test phone numbers will work.');
    }
    return { auth, ...mod };
  })();
  return cachedPromise;
}
